import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, WithChildren} from '../../../helpers'
import {MouseEventHandler} from 'react'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  /** When set, the item highlights ONLY on an exact path match. Use for a
   *  route that is a path-prefix of a sibling item (e.g. '/accounting' vs
   *  '/accounting/cashflow') so both don't highlight at once. */
  exact?: boolean
  onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> // adding onClick prop
}

const AsideMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  exact = false,
}) => {
  const {pathname} = useLocation()
  const current = pathname.split(/[?#]/)[0]
  const isActive = exact ? current === to : checkIsActive(pathname, to)

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', {active: isActive})} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className='menu-title'>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export {AsideMenuItem}
